import { theme } from 'lib/theme';
import * as React from 'react';
import { View } from 'react-native';
import { TextField } from './Field/TextField';
import { ICONS } from './Icon';
import { ViewWithSeparators } from './ViewWithSeparators';
import { randomKey } from 'lib/riskbase';

type Props = {
  children?: React.ReactNode;
  leftChildren?: React.ReactNode;
  leftChildrenWithBox?: boolean;
  showSearch?: boolean;
  searchValue?: string;
  searchDisabled?: boolean;
  searchPlaceholder?: string;
  onSearch: (value: string) => void;
};

export const HeaderToolbar = ({
  children,
  leftChildren,
  leftChildrenWithBox,
  showSearch = true,
  searchDisabled,
  searchPlaceholder,
  searchValue,
  onSearch,
}: Props) => {
  const searchFieldKey = React.useRef('initKey');
  const lastIncomingSearchValue = React.useRef(searchValue);
  if (lastIncomingSearchValue.current !== searchValue) {
    searchFieldKey.current = randomKey();
  }
  lastIncomingSearchValue.current = searchValue;

  return (
    <View
      style={{
        height: 56,
        flexDirection: 'row',
        paddingHorizontal: theme.paddingHorizontal,
        alignItems: 'stretch',
        paddingBottom: theme.paddingHorizontal,
      }}
    >
      {!!leftChildren && leftChildrenWithBox ? (
        <View
          style={{
            backgroundColor: theme.colors.white50,
            padding: theme.paddingHorizontalHalf,
            borderRadius: 999,
            flex: 1,
          }}
        >
          {leftChildren}
        </View>
      ) : (
        leftChildren
      )}
      {showSearch && (
        <View
          style={{ flex: 1, position: 'relative', justifyContent: 'center' }}
        >
          <TextField
            disabled={searchDisabled}
            key={searchFieldKey.current}
            value={searchValue}
            iconLeft={ICONS.MagnifyingGlassLight}
            onChange={onSearch}
            enableManualOnChange={true}
            placeholder={searchPlaceholder}
            clearable
            autoCorrect={false}
            autoComplete="off"
            autoCapitalize="none"
            autoFocusWeb
            autoFocusDelay
            syncIncomingValue
            inputStyle={{ minHeight: null, alignSelf: 'stretch' }}
            containerStyle={{
              paddingHorizontal: theme.paddingHorizontalHalf,
              borderRadius: 999,
              flex: 1,
            }}
          />
        </View>
      )}
      <ViewWithSeparators
        horizontal
        style={{
          marginLeft: theme.paddingHorizontal,
          alignItems: 'center',
          backgroundColor: theme.colors.white50,
          padding: theme.paddingHorizontalHalf,
          borderRadius: 999,
        }}
        separatorMargin={2}
        separatorColor="transparent"
      >
        {children}
      </ViewWithSeparators>
    </View>
  );
};
